<template>
  <div style="width:100%;height:100%;background:#f9f9f9;padding:50px 40px;">
    <div style="max-width:1580px;margin:0 auto;padding:0 140px 80px 140px;background:#ffffff;">
      <p style="line-height:100px;text-align:center;font-size:24px;font-weight:bold;">公告</p>
      <div style="height:100px;border-bottom:1px solid #e5e5e5;font-size:24px;">
        <p style="line-height:100px;">{{title}}</p>
      </div>
      <div v-html="content" style="margin-top:30px;margin-bottom:180px;"></div>
      <p style="text-align:right">{{time}}</p>
    </div>
  </div>

</template>

<script>
export default {
  name: "SystemNoticePage",
  data(){
    return{
      title:"",
      content:"",
      time:""
    }
  },
  methods:{
    getNoticeInfo(){
      this.$axios({
        method:"get",
        url:"/authorApi/notice/getNoticeById",
        params:{
          noticeId:this.$route.query.noticeId,
          system:1
        }
      }).then((resultData)=>{
        resultData = resultData.data;
        if(resultData.status === 200){
          this.title = resultData.data.title;
          this.content = resultData.data.content;
          this.time = resultData.data.gmtCreatetime;
        }
        else{
          console.log(resultData.status + resultData.message);
        }
      }).catch((err)=>{
        console.log(err);
      });
    },

  },
  mounted(){
    this.getNoticeInfo();
  }
}
</script>

<style scoped>

</style>